import request from '@/router/axios';
export function getListpage(obj) {
  return request({
    url: '/order/page',
    method: 'POST',
    data: obj,
  });
}
/**
 *  获取动态表单回显值
 */
export function getDynamicFormValue(id) {
  return request({
    url: '/order/getOrderInfo/'+id,
    method: 'GET',
  });
}
/**
 *  根据id修改数据
 * @param obj
 */
export function updateListpage(obj) {
  return request({
    url: '/order/update',
    method: 'put',
    data: obj,
  });
}

export function addListpage(obj) {
  return request({
    url: '/order/add',
    method: 'post',
    data: obj,
  });
}
export function adminAudit(obj) {
  return request({
    url: '/order/adminAudit',
    method: 'post',
    data: obj,
  });
}

export function batchUpdateStatus(obj) {
  return request({
    url: '/order/batchUpdate',
    method: 'post',
    data: obj,
  });
}
//根据城市加载司机信息，不传默认查询所有
export function getDriverByCityCode(obj) {
  return request({
    url: '/order/getDriverByCityCode',
    method: 'post',
    data: obj,
  });
}
//根据项目价值司机
export function getDriverByProject(obj) {
  return request({
    url: '/order/getDriverByProject',
    method: 'post',
    data: obj,
  });
}
//派单
export function disPatchOrder(obj) {
  return request({
    url: '/order/disPatchOrder',
    method: 'post',
    data: obj,
  });
}
//导出订单
export function exportOrder(obj) {
  return request({
    url: '/order/exportOrder',
    responseType: 'blob', // 代表内存之中的一段二进制数据 必须加
    method: 'get',
    params: obj
  })
}
//加载订单的司机列表
export function getOrderDriverList(id) {
  return request({
    url: '/order/getOrderDriverList/' + id,
    method: 'GET',
  });
}
//判断司机在某个日期是否已经存在订单
export function queryHasOrderByDriver(obj) {
  return request({
  url: '/order/queryHasOrderByDriver',
  method: 'post',
  data: obj,
});
}
//月度订单统计
export function queryMonthOrderTotal() {
  return request({
    url: '/order/queryMonthOrderTotal',
    method: 'GET',
  });
}
//订单概况
export function queryOrderNumTotal(obj) {
  return request({
    url: '/order/queryOrderNumTotal',
    method: 'post',
    data: obj,
  });
}
//区域订单统计
export function queryAreaOrderNumTotal() {
  return request({
    url: '/order/queryAreaOrderNumTotal',
    method: 'GET',
  });
}
//查询派单城市列表
export function getDispatchCityList(obj) {
  return request({
    url: '/order/getDispatchCityList',
    method: 'post',
    data: obj,
  });
}
//添加派单城市
export function addDispatchCityInfo(obj) {
  return request({
    url: '/order/addDispatchCityInfo',
    method: 'post',
    data: obj,
  });
}
//删除派单城市
export function delDispatchCityById(obj) {
  return request({
    url: '/order/delDispatchCityById',
    method: 'post',
    data: obj,
  });
}
export function getHighSeasList(obj) {
  return request({
    url: '/order/getHighSeasList',
    method: 'post',
    data: obj,
  });
}
//添加派单城市
export function addHighSeasInfo(obj) {
  return request({
    url: '/order/addHighSeasInfo',
    method: 'post',
    data: obj,
  });
}
//删除派单城市
export function delHighSeasInfoById(obj) {
  return request({
    url: '/order/delHighSeasInfoById',
    method: 'post',
    data: obj,
  });
}

//加载订单基础信息设置--------------
export function qryBaseInfoSet(id) {
  return request({
    url: '/order/qryBaseInfoSet/'+id,
    method: 'get',
  });
}
export function delBaseInfoSet(id) {
  return request({
    url: '/order/delBaseInfoSet/'+id,
    method: 'post',
  });
}
//更新订单基础设置
export function updBaseInfoSet(obj) {
  return request({
    url: '/order/updBaseInfoSet',
    method: 'post',
    data: obj,
  });
}
export function getBaseInfoList(obj) {
  return request({
    url: '/order/getBaseInfoList',
    method: 'post',
    data: obj,
  });
}
//加载费用基础信息设置--------------
export function qryCostInfoSet(id) {
  return request({
    url: '/order/qryCostInfoSet/'+id,
    method: 'get',
  });
}
export function delCostInfoSet(id) {
  return request({
    url: '/order/delCostInfoSet/'+id,
    method: 'post',
  });
}
//更新订单基础设置
export function updCostInfoSet(obj) {
  return request({
    url: '/order/updCostInfoSet',
    method: 'post',
    data: obj,
  });
}
export function updBatchCostInfoSet(obj) {
  return request({
    url: '/order/updBatchCostInfoSet',
    method: 'post',
    data: obj,
  });
}

export function getCostInfoList(obj) {
  return request({
    url: '/order/getCostInfoList',
    method: 'post',
    data: obj,
  });
}
//加载企业下的员工
export function queryEmpList(obj) {
  return request({
    url: '/wechat/emp/queryEmpList',
    method: 'post',
    data: obj,
  });
}
//费用结算
export function batchCalcAmount(obj) {
  return request({
    url: '/order/batchCalcAmount',
    method: 'post',
    data: obj,
  });
}

//更新订单的客户借款状态
export  function  updateSettledFlagByDate(obj) {
  return request({
    url: '/order/updateSettledFlagByDate',
    method: 'post',
    data: obj,
  });
}
export function getClockList(id) {
  return request({
    url: '/order/clockInfo/'+id,
    method: 'get',
  });
}

